import * as React from 'react'

function SvgMc(props) {
	return (
		<svg viewBox="0 0 750 600" width="1em" height="1em" {...props}>
			<path fill="#FFF" d="M0 0h750v600H0z" />
			<path fill="#CE1126" d="M0 0h750v300H0z" />
		</svg>
	)
}

export default SvgMc
